<template>
  <div class="section" id="about">
    <div class="section_inner">
      <div class="about">
        <div class="left">
          <div class="image">
            <img src="img/thumbs/1-1.jpg" alt="" />
            <div class="main" data-img-url="img/about/1.jpg"></div>
          </div>
        </div>
        <div class="right">
          <div class="short">
            <h3 class="name">Aiden <span class="coloring">Developer</span></h3>
            <h3 class="job">
              <AnimationText />
            </h3>
          </div>
          <div class="text">
            <p>
              My name is <span>Aiden de Castro.</span> I am an AI engineer, graphic designer,UI/UX designer, P.M. and
              I'm an entrepeneur with a small company called AI. Dev Group specialized in developing AI solutions for small to medium enterprises. With 6 years
              experience as a professional web developer and recently AI specialist and product manager, I have acquired
              the skills and knowledge for developing suitable solutions for every need our clients require.
            </p>
          </div>
          <div class="button" id="aboutPopup">
            <a href="#">Learn More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimationText from "./AnimationText.vue";
export default {
  name: `AboutComponent`,
  data() {
    return {
      open: false,
    };
  },
  components: {
    AnimationText,
  },
};
</script>

<style scoped>
.modalbox {
  top: -90px;
}
</style>
